import React, { useEffect, useState } from "react";
import { listOutbox } from "../offline/webOutbox";
import { flushWebOutbox } from "../offline/outboxSyncWeb";

export default function OfflineOutboxPage() {
  const [items, setItems] = useState<any[]>([]);

  async function load() {
    const rows = await listOutbox().catch(() => []);
    setItems(Array.isArray(rows) ? rows : []);
  }

  useEffect(() => {
    void load();
  }, []);

  return (
    <div className="space-y-4">
      <div>
        <h1 className="text-xl font-semibold">Offline outbox</h1>
        <p className="text-sm text-slate-400">Queued offline jobs for resend.</p>
      </div>

      <button
        type="button"
        onClick={async () => { await flushWebOutbox().catch(() => null); await load(); }}
        className="rounded-xl border border-slate-700 px-4 py-2 text-sm hover:border-slate-500"
      >
        Flush now
      </button>

      {!items.length && (
        <div className="text-sm text-slate-400">Outbox empty.</div>
      )}

      <div className="grid gap-3">
        {items.map((item) => (
          <div key={item.id} className="rounded-2xl border border-slate-800 bg-slate-900/40 p-4">
            <div className="font-semibold text-slate-100">{item.kind}</div>
            <div className="text-xs text-slate-400 mt-1">id: {item.id}</div>
            <div className="text-xs text-slate-400">retryCount: {item.retryCount}</div>
            <div className="text-xs text-slate-400">nextAttemptAt: {item.nextAttemptAt ? new Date(item.nextAttemptAt).toISOString() : "n/a"}</div>
            {item.lastError ? <div className="text-xs text-rose-300 mt-1">lastError: {item.lastError}</div> : null}
          </div>
        ))}
      </div>
    </div>
  );
}
